<template>
  <div class="folder-tree">
    <div class="folder-header">
      <div class="title">选择数据范围</div>
    </div>
    <div class="folder-content">
      <div class="folder-item" v-for="(item, index) of tree" :key="index">
        <div class="folder-item-title">
          <div class="title-wrapper">
            <v-icon name="folder"/>
            <span class="title">{{ item.name }}</span>
          </div>
        </div>
        <div class="folder-item-content" v-for="(child, idx) of item.bos" :key="idx">
          <div
            class="content-item"
            :class="{active: current === child.id}"
            @click="itemClick(child)"
          >
            {{ child.name }}({{ child.count }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
const req = require.context('./assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);
export default {
  name: 'FolderTree',
  props: {
    tree: {
      type: Array,
      default() {
        return []
      }
    },
    current: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {}
  },
  methods: {
    itemClick(item) {
      this.$emit('click', item);
    }
  },
  mounted() {
    console.log(this.tree, 324324234);
  }
}
</script>

<style lang="less" scoped>
.folder-tree {
  width: 240px;
  border-radius: 4px;
  border: 1px solid  rgba(18, 42, 79, 0.08);
  background: #fff;
  .folder-header {
    padding: 8px 4px 8px 12px;
    border-bottom: 1px solid rgba(18, 42, 79, 0.08);
    color: rgba(0, 1, 10, 0.93);
    padding: 12px;
    .title {
      font-size: 16px;
      line-height: 24px;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
    }
  }
  .folder-content {
    padding: 12px;
    color: rgba(0, 1, 10, 0.93);
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    .folder-item {
      &-title {
        display: flex;
        align-items: center;
        .title-wrapper {
        }
        .title {
          margin-left: 4px;
        }
      }
      &-content {
        margin-left: 16px;
        .content-item {
          cursor: pointer;
          padding: 0 4px;
          border-radius: 3px;
          margin: 2px 0;
          word-break: break-all;
          &.active {
            background: rgba(241, 246, 255, 1);
          }
          &:not(.active):hover {
            background: rgba(36, 56, 97, .05);
          }
        }
      }
    }
  }
}
</style>